import {
  checkMultiple,
  Permission,
  PERMISSIONS,
  PermissionStatus,
  Rationale,
  request,
} from 'react-native-permissions'
import { CURRENT_OS, OS } from 'infra/constant'
import { makeAutoObservable, runInAction } from 'mobx'

export enum PermissionType {
  location = 'location',
  camera = 'camera',
  photoRead = 'photoRead',
}
const permissionTypes: PermissionType[] = [PermissionType.location] //  Object.values(PermissionType)

const LibPermissions: Record<
  PermissionType,
  Partial<Record<OS, Permission>>
> = {
  location: {
    [OS.ANDROID]: PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION,
    [OS.IOS]: PERMISSIONS.IOS.LOCATION_WHEN_IN_USE,
  },
  camera: {
    [OS.ANDROID]: PERMISSIONS.ANDROID.CAMERA,
    [OS.IOS]: PERMISSIONS.IOS.CAMERA,
  },
  photoRead: {
    [OS.ANDROID]: PERMISSIONS.ANDROID.READ_EXTERNAL_STORAGE,
    [OS.IOS]: PERMISSIONS.IOS.PHOTO_LIBRARY,
  },
}

const getLibPermission = (p: PermissionType): Permission => {
  const permission = LibPermissions[p][CURRENT_OS]
  if (!permission) {
    throw new Error(`Permission ${p} is not supported on ${CURRENT_OS}`)
  }
  return permission
}

class PermissionStore {
  location: PermissionStatus | null = null
  camera: PermissionStatus | null = null
  photoRead: PermissionStatus | null = null

  constructor() {
    makeAutoObservable(this)
  }

  async checkAll() {
    const statuses = await checkMultiple(
      permissionTypes.map((p) => getLibPermission(p)),
    )
    runInAction(() => {
      permissionTypes.forEach((p) => {
        this[p] = statuses[getLibPermission(p)]
      })
    })
  }

  async request(p: PermissionType, rationale?: Rationale) {
    const status = await request(getLibPermission(p), rationale)
    runInAction(() => {
      this[p] = status
    })
  }
}

export const permissionStore = new PermissionStore()
